<template>
<!-- <div class="spin-wrapper"> -->
  <div>
  <div class="spin-bg"></div>

  <div ref="spinContainer" class="spin-container">
    <div class="close-detail" @click="closeSpin"></div>
    <v-stage ref="stage" :config="stageSize">
      <v-layer ref="layer">
        <v-sprite
          ref="sprite"
          :config="{
            image: image,
            animation: 'idle',
            animations: animations,
            frameRate: 6,
            listening: true
          }"
        />
      </v-layer>
    </v-stage>
  </div>
<!-- </div> -->
  </div>
</template>

<script>
import { inject } from "vue";



export default {
  name: "SpinHouse",
  components: {
  },
  props: {
    triggerClose: {
      type: Boolean,
      default: false
    },
    sprite: {
      type: Object,
      default: null,
    },
    anims: {
      type: Object,
      default: null
    },
    stageSize: {
      type: Object,
      default: null
    }
  }  ,
  setup() {
    const store = inject("store");
    return {
      state: store.state,
			actions: store.actions
    };
  },
  data: function(){
    return {
      image: null,
      animations: this.anims,
      node: null,
      playForward: true
    }
  },
  created() {
  },
  mounted() {

    // console.log(this.animations.idle.length);
    const animLen = (this.animations.idle.length / 4) - 1;
    
    const image = new window.Image();
    image.src = this.sprite;
    image.onload = () => {
      // set image only when it is loaded
      this.image = image;
      this.node = this.$refs.sprite.getNode();
      this.node.start();
      // console.log('node', this.node);
      const that = this;
      this.node.on('frameIndexChange.button', function () {
        // console.log(animLen, this.frameIndex());
        if(animLen == this.frameIndex()) {
          that.node.stop();
        }
      });
    };

    this.resize();
  },
  methods: {
    resize() {

    },
    closeSpin() {
      // this.node.stop();
      // const node = this.$refs.sprite.getNode();
      this.$emit('set-showspin', false);
      this.shouldClose = true;
    },
    reverseSpin() {
      
      this.playForward = !this.playForward;
      console.log('reverseSpin', this.playForward);
      if(this.playForward) {
        this.node.animation('idle');
      } else {
        this.node.animation('reverse');
      }
      this.node.start();

    }
  },
  watch: {
    triggerClose(newVal) {
      console.log('triggerClose', newVal);
      this.reverseSpin();
    }
  }
}
</script>

<style lang="scss">
.spin-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(100vh - var(--vh-offset, 0px));
  background: #00000070;
  z-index: 9;
}
  .spin-container {
    background: #fff;
    // position: absolute;
    // bottom: 40px;
    // left: 50%;
    position: relative;
    margin: 30px auto 0;
    width: 35vh;
    height: 0;
    padding-top: 35vh;
    max-width: 428px;
    max-height: 428px;
    z-index: 1;
    border: 5px solid #df4a9b;
    &.home-spin {
      top: 50%;
      bottom: auto;
      transform: translate(-50%, -50%);
      position: absolute;
      left: 50%;
    }
    &>div:not(.close-detail) {
      width: 100% !important;
      height: 100% !important;
      position: absolute;
      top: 0;
      left: 0;
    }
    .konvajs-content {
      width: 100% !important;
      height: 100% !important;
      canvas {
        width: 100% !important;
        height: 100% !important;
      }
    }
    .close-detail {
      right: 0;
    }
    @media screen and (min-width: 440px) {
      padding-top: 0;
      height: 35vh;
    }
  }
</style>
